const students = {
  all_students: '🎓 Todos los estudiantes',
  label: 'estudiantes',
  create: 'Crear Nuevo Estudiante',
  active: 'Activo',
  inactive: 'Inactivo',
  firstname: 'Nombre',
  lastname: 'Apellido P',
  lastname2nd: 'Apellido M',
  course: 'Curso',
  courses: 'Cursos',
  school: 'Colegio',
  only_independent: 'Solo independientes',
  independent: 'Independiente',
  independent_notice: 'Alumno independiente: no tiene colegio ni curso, y no se le pueden asignar.',
  diagnostics_not_applicable: 'Diagnóstico: no aplica a alumnos independientes.',
  student_grade: 'Grado del alumno',
  grade_option_0: 'Kínder',
  grade_option_n: '{grade}.º grado',
  state: 'Estatus',
  edit: 'Editar',
  username: 'Usuario',
  register_date: 'Fecha ingreso',
  email: 'Correo',
  last_access: 'Último acceso',
  without_last_access: 'No ha ingresado',
  create_new_information: '🔑 Nueva contraseña',
  section: 'Sección',
  sections: 'Secciones',
  select_section: 'Seleccionar sección',
  general_information: '✍ Información del Estudiante 📓',
  creation_date: 'Fecha de creación',
  dni: 'DNI',
  student_name: 'Nombre del Alumno',
  student_parent_lastname: 'Apellido Paterno',
  student_mother_lastname: 'Apellido Materno',
  birthdate: 'Fecha de Nacimiento',
  country: 'País',
  select_country: 'Seleccionar un País',
  grade: 'Grado',
  grades: 'Grados',
  select_grade: 'Seleccionar un grado',
  select_courses: 'Seleccionar cursos',
  section_required: 'Sección es requerida',
  dni_required: 'DNI es requerido',
  dni_length_valid: 'La longitud mínima para el DNI es de 8 carácteres',
  dni_with_blank_spaces: 'DNI contiene espacios en blanco',
  firstname_required: 'El nombre del alumno es requerido',
  lastname_required: 'El apellido paterno es requerido',
  lastname2nd_required: 'El apellido materno es requerido',
  birthDate_required: 'La fecha de nacimiento es requerida',
  country_required: 'El País es requerido',
  school_required: 'El colegio es requerido',
  grade_required: 'El grado es requerido',
  new_password_was_set: 'Contraseña establecida satisfactoriamente',
  users_updated: 'Usuarios actualizados satisfactoriamente',
  user_saved: 'Usuario guardado satisfactoriamente',
  impersonate: 'Impersonar',
  impersonate_opening: 'Abriendo sesión como',
  impersonate_choose_app: '¿Ir a la app de Profesores? Cancelar abre DataSystem.',
  users_disabled: '🚫 Alumno(s) inhabilitado(s) correctamente.',
  users_enabled: '✅ Alumno(s) habilitado(s) correctamente.',
  action_error: '⚠️ ¡Algo salió mal! Intenta realizar esta misma acción más tarde.',
  disable_user_btn: 'Deshabilitar Alumno(s)',
  enable_user_btn: 'Habilitar Alumno(s)',
  select_school: 'Seleccionar colegio',
  email_invalid: 'Correo inválido',
  student_not_found: 'Usuario no encontrado',
  load_partial_error: 'No se pudo cargar toda la información del alumno. Inténtalo de nuevo.',
  new_password_not_saved: 'No se pudo establecer la nueva contraseña',
  birth_date: 'Fecha de nacimiento',
  generate_username: '¿Generar nombre de usuario?',
  dni_invalid: 'Revisa el formato o espacios en blanco del DNI',
  select_country_first: 'Elige un país primero',
  select_school_first: 'Elige un colegio primero',
  created_title: 'Alumno creado',
  created_credentials: 'Usuario: {username} · Contraseña inicial: {password}',
  created_must_change: 'El alumno deberá cambiar la contraseña en su primer ingreso.',
  create_another: 'Crear otro',
  create_error: 'No se pudo crear el alumno. Inténtalo de nuevo.',
  dni_exists: 'El DNI o el usuario ya existe',
  create_independent: 'Crear alumno independiente',
  lastname_single: 'Apellido',
  email_optional: 'Correo (opcional)',
  grade_optional: 'Grado (opcional)',
  grade_optional_hint: 'Si lo dejas vacío, el alumno lo elige al ingresar.',
  time_zone_optional: 'Zona horaria (opcional)',
  independent_copy_warning: 'Copia el usuario y la contraseña ahora: no se volverán a mostrar.',
  independent_forbidden: 'No tienes permiso para crear alumnos independientes. Solo un administrador de Beeverso puede hacerlo.',
  independent_invalid: 'Revisa los datos del formulario: hay un valor que no es válido (por ejemplo, la zona horaria).',
};

export default students;
